export default "__VITE_ASSET__DugX695m__"